import Vue from 'vue';

export default {
    namespaced: true,
    state: {
        isOpen: false,
        selectedGroup: null,
    },
    mutations: {
        setSidebarDrawerIsOpen(state, value) {
            Vue.set(state, 'isOpen', value);
        },
        setSelectedGroup(state, value){
            Vue.set(state, 'selectedGroup', value);
        }
    },
    actions: {
        setSidebarDrawerIsOpen({ commit }, value) {
            commit('setSidebarDrawerIsOpen', value);
        },
        setSelectedGroup({ commit }, value){
            commit('setSelectedGroup', value);
        }
    },
    getters: {
        isSidebarDrawerOpen: (state) => state.isOpen,
        getSelectedGroup: (state) => state.selectedGroup,
    },
}
